import { isEnumValid } from '@philips-internal/oswald-ui-utils';
import { wrapCompositeType, wrapType } from './util.js';
var IntellisenseExpectedType;
(function (IntellisenseExpectedType) {
    IntellisenseExpectedType["ANY"] = "Any";
    IntellisenseExpectedType["DOMAIN"] = "Domain";
    IntellisenseExpectedType["EXPRESSION"] = "Expression";
    IntellisenseExpectedType["URL"] = "URL";
})(IntellisenseExpectedType || (IntellisenseExpectedType = {}));
const unworthyOfBeingPlaceholder = [
    IntellisenseExpectedType.ANY,
];
function creator(base, expectedType) {
    if (!isEnumValid(IntellisenseExpectedType, expectedType)) {
        throw new Error('[Intellisense]: The prop-type definition should provide the expected type as the second parameter.');
    }
    const type = wrapType(base, { expectedType });
    if (unworthyOfBeingPlaceholder.includes(expectedType)) {
        return type;
    }
    return type.placeholder(expectedType.toLowerCase());
}
const wrappedIntellisense = wrapCompositeType(creator, { type: 'intellisense' }, false);
function intellisense(type, expectedType) {
    return wrappedIntellisense(type, expectedType);
}
export { IntellisenseExpectedType, intellisense, };
//# sourceMappingURL=intellisense.js.map